const SUPPORTED = ['es', 'en', 'pt'];

export const apiLanguage = (language, fallback) => {
  const base = (language || '').toLowerCase().split('-')[0];
  return SUPPORTED.includes(base) ? base : fallback;
};
